module.exports = {
    GoogleMapApiKey: process.env.REACT_APP_GOOGLE_MAPS_API_KEY,
    StripeKey: process.env.REACT_APP_STRIPE_KEY,
    BaseApi: process.env.REACT_APP_BASE_URL || "http://localhost:5000",
    BaseFront: process.env.REACT_APP_BASE_FRONT || "http://localhost:3000",
    SecretPass: process.env.REACT_APP_SECRET_PASS || 'LKJFELDKSHJFHSIUDHGFIH'
};